import { OnInit } from '@angular/core';
import { WorkspaceService } from '../services/workspace.service';
import { PageContent } from '../objects/WorkObject';
import { DatePipe } from '@angular/common';
var KhamisDialogComponent = /** @class */ (function () {
    function KhamisDialogComponent(workspaceService) {
        this.workspaceService = workspaceService;
        //private reportGroupList:ReportGroup[] = [];
        this.conversationResultList = [];
    }
    Object.defineProperty(KhamisDialogComponent.prototype, "searchResultId", {
        set: function (searchResultId) {
            if (searchResultId) {
                this.componentId = searchResultId;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KhamisDialogComponent.prototype, "searchResultChanged", {
        set: function (searchResultId) {
            var _this = this;
            var id = "00000000-0000-0000-0000-000000000000";
            if (this.componentId) {
                id = this.componentId;
            }
            this.workspaceService.getSearchResult(id).subscribe(function (result) {
                if (result) {
                    _this.conversationResultList = JSON.parse(result);
                    _this.conversationResultList.forEach(function (conv) {
                        conv.EPICGroups.forEach(function (group) {
                            group.EPICs.forEach(function (epic) {
                                if (epic.TemplateType == 'WebContent') {
                                    if (epic.Width > 32) {
                                        group.Width = this.reportGroupWidth;
                                        group.FullWidth = "repeat (36, 1fr)";
                                        group.FullHeight = "repeat(" + epic.Height + ", 45px)";
                                        epic.Width = this.reportGroupWidth;
                                    }
                                }
                            });
                        });
                    });
                    _this.reverseSortConversation(_this.conversationResultList);
                    _this.conversationResultList.forEach(function (element) {
                        element.ConversationMessage.MessageDateTimeConverted = new DatePipe("en-US").transform(element.ConversationMessage.MessageDateTime, "dd/MM/yyyy hh:mm:ss a");
                    });
                    // this.conversationResultList.forEach(element => {
                    //     element.EPICGroups.forEach(element => {
                    //       this.setStartRow(element.EPICs);
                    //     });
                    // });
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    KhamisDialogComponent.prototype.reverseSortConversation = function (conversationResultList) {
        this.conversationResultList = conversationResultList.sort(function (a, b) {
            if (a.ConversationOrder < b.ConversationOrder) {
                return 1;
            }
            else if (a.ConversationOrder > b.ConversationOrder) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    KhamisDialogComponent.prototype.setStartRow = function (reportGroup) {
        var startRow = 1;
        reportGroup.forEach(function (x) {
            x.StartRow = startRow;
            if (x.BreakAfter)
                startRow = startRow + x.Height;
        });
    };
    KhamisDialogComponent.prototype.ngOnInit = function () {
    };
    KhamisDialogComponent.prototype.getRelatedEpics = function (conversationResult, epicGroup) {
        var _this = this;
        this.workspaceService.getRelatedEPICs(conversationResult.ConversationMessage.ConversationId, conversationResult.ConversationMessage.MessageId, epicGroup.GroupId, epicGroup.GroupOrder.toString()).subscribe(function (result) {
            var converse = JSON.parse(result);
            var itemIndex = _this.conversationResultList.findIndex(function (item) { return item.ConversationMessage.ConversationId == converse.ConversationMessage.ConversationId; });
            _this.conversationResultList[itemIndex] = converse;
            _this.conversationResultList[itemIndex].ConversationMessage.MessageDateTimeConverted = new DatePipe("en-US").transform(_this.conversationResultList[itemIndex].ConversationMessage.MessageDateTime, "dd/MM/yyyy hh:mm:ss a");
            document.querySelectorAll('.body-wrapper').item(0).scrollTop = 130;
        });
    };
    KhamisDialogComponent.prototype.toggle = function (id) {
        if (this.messageId == id) {
            this.messageId = '';
        }
        else {
            this.messageId = id;
        }
    };
    return KhamisDialogComponent;
}());
export { KhamisDialogComponent };
